var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplicantCreatedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20896"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#235594"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 21043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6953 15.752C10.6953 13.5145 12.5091 11.7007 14.7466 11.7007C16.9841 11.7007 18.7979 13.5145 18.7979 15.752C18.7979 17.9895 16.9841 19.8033 14.7466 19.8033C12.5091 19.8033 10.6953 17.9895 10.6953 15.752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3721 21.3332C11.4816 20.8516 12.9373 20.7036 14.7464 20.7036C16.5571 20.7036 18.0139 20.8519 19.1237 21.3345C20.3327 21.8602 21.0675 22.7556 21.4527 24.0199C21.6332 24.6125 21.1881 25.205 20.5747 25.205H8.91979C8.30569 25.205 7.85965 24.6116 8.04071 24.0179C8.42637 22.7535 9.1623 21.8583 10.3721 21.3332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7364 9.26369C26.088 9.61527 26.088 10.1853 25.7364 10.5369L22.5854 13.6879C21.9852 14.2881 21.0122 14.2881 20.412 13.6879L19.0615 12.3375C18.71 11.9859 18.71 11.4158 19.0615 11.0643C19.4131 10.7127 19.9831 10.7127 20.3347 11.0643L21.4987 12.2282L24.4632 9.26369C24.8148 8.9121 25.3849 8.9121 25.7364 9.26369Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicantCreatedLogo);
export default __webpack_public_path__ + "static/media/ApplicantCreatedLogo.6d28bf4ac17922cba0d095784a2ca98f.svg";
export { ForwardRef as ReactComponent };